import { render, staticRenderFns } from "./DeleteRole.vue?vue&type=template&id=32501458&lang=pug"
import script from "./DeleteRole.vue?vue&type=script&lang=js"
export * from "./DeleteRole.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports